import React, { useRef, useLayoutEffect, useState, useCallback, useContext } from 'react';
import { useSpring, useTransition, animated } from 'react-spring';
import classNames from 'classnames';
import useOpenStatus from './hooks/use-open-status';
import AccordionContext from './context/accordion-context';

// @ts-ignore TS(2322): Type 'string' is not assignable to type 'ReactElem... Remove this comment to see the full error message
function AccordionContent({
  component: Component = 'div',
  shouldRenderCollapsed = false,
  itemId,
  children,
  contentWrapperClassName = '',
  ...otherProps
}) {
  const [contentHeight, setContentHeight] = useState(0);
  const isOpen = useOpenStatus(itemId);
  // @ts-ignore TS(2339): Property 'shouldPreventAnimation' does not exist o... Remove this comment to see the full error message
  const { shouldPreventAnimation } = useContext(AccordionContext);
  const contentRef = useRef(null);

  const resetContentHeight = useCallback(() => {
    setContentHeight((height) => (contentRef.current && contentRef.current.scrollHeight) || height);
  }, [contentRef, setContentHeight]);

  useLayoutEffect(() => {
    resetContentHeight();

    window.addEventListener('resize', resetContentHeight);
    return () => window.removeEventListener('resize', resetContentHeight);
  });

  const contentStyles = useSpring({
    maxHeight: isOpen ? `${contentHeight}px` : '0px',
    overflow: 'hidden',
  });

  const transitions = useTransition(isOpen, null, {
    from: { maxHeight: '0px', overflow: 'hidden' },
    enter: { maxHeight: `${contentHeight}px` },
    update: { maxHeight: `${contentHeight}px` },
    leave: { maxHeight: '0px' },
  });

  const contentWrapperClassNames = classNames({
    [contentWrapperClassName]: contentWrapperClassName,
    [`${contentWrapperClassName}--closed`]: contentWrapperClassName && !isOpen,
  });

  if (shouldPreventAnimation) {
    return (
      <React.Fragment>
        {isOpen && (
          <div className={contentWrapperClassNames}>
            {/* @ts-ignore TS(2604): JSX element type 'Component' does not have any con... Remove this comment to see the full error message */}
            <Component {...otherProps} ref={contentRef}>
              {children}
            </Component>
          </div>
        )}
        {!isOpen && shouldRenderCollapsed && (
          <div
            style={{ maxHeight: '0px', overflow: 'hidden' }}
            className={contentWrapperClassNames}
          >
            {/* @ts-ignore TS(2604): JSX element type 'Component' does not have any con... Remove this comment to see the full error message */}
            <Component {...otherProps} ref={contentRef}>
              {children}
            </Component>
          </div>
        )}
      </React.Fragment>
    );
  }

  if (shouldRenderCollapsed) {
    return (
      <animated.div style={contentStyles} className={contentWrapperClassNames}>
        {/* @ts-ignore TS(2604): JSX element type 'Component' does not have any con... Remove this comment to see the full error message */}
        <Component {...otherProps} ref={contentRef}>
          {children}
        </Component>
      </animated.div>
    );
  }

  return transitions.map(
    ({ item, key, props: styles }) =>
      item && (
        <animated.div key={key} style={styles} className={contentWrapperClassNames}>
          {/* @ts-ignore TS(2604): JSX element type 'Component' does not have any con... Remove this comment to see the full error message */}
          <Component {...otherProps} ref={contentRef}>
            {children}
          </Component>
        </animated.div>
      )
  );
}

export default AccordionContent;
